export class VisitaReciboConforme {


    public idCompania: string;
    public idPunto: string;
    public idVisita: string;
    public idViaje: string;
    public nombrePunto: string;
    public totalFrios: number;
    public totalSecos: number;
    public totalBultos: number;
    public numeroDocumento: string;

    public fechaProgramada: Date;
    public montoTotal: number;
    public condicionPago: string;
    public numeroOrden: string;

    public fechaFactura: Date;
}
